// eslint-disable-next-line no-restricted-imports
import { Record } from '@gonfalon/immutable-shim/immutableShim';

export class ScimConfig extends Record({
  _provider: '',
}) {
  isEnabled() {
    return !!this._provider;
  }
}

export function createScimConfig(props = {}) {
  return props instanceof ScimConfig ? props : new ScimConfig(props);
}
